export enum QrCodeFormat {
  Undefined,
  Html,
  Png,
  Jpg,
  Pdf,
  Svg
}
